/** Разбор текста на обычные куски и ссылки. */

import { linkPattern } from '@ak/shared';

/**
 * Знаки, которые почти всегда стоят после ссылки, а не входят в неё:
 * `посмотри (youtu.be/abc), там видно` — скобка и запятая к адресу не
 * относятся.
 */
const TRAILING = /[.,;:!?)\]}»"']+$/;

export interface TextPart {
  text: string;
  /** Адрес, если кусок — ссылка. `null` — обычный текст. */
  href: string | null;
}

/**
 * Короткая подпись ссылки: площадка и хвост адреса.
 *
 * Полный адрес занимает пол-экрана и всё равно не читается — в заявках это
 * ссылки на записи с длинными наборами букв. Домен отвечает на главный
 * вопрос «куда ведёт», а хвост позволяет отличить две ссылки подряд.
 */
export function linkLabel(href: string): string {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return href;
  }

  const host = url.hostname.replace(/^www\./, '');
  const tail = `${url.pathname}${url.search}`.replace(/\/$/, '');

  if (tail === '' || tail === '/') {
    return host;
  }

  return tail.length <= 24 ? `${host}${tail}` : `${host}…${tail.slice(-16)}`;
}

export function splitByLinks(source: string): TextPart[] {
  const parts: TextPart[] = [];
  let index = 0;

  for (const match of source.matchAll(linkPattern())) {
    const start = match.index;
    const raw = match[0];

    // Хвостовые знаки возвращаем в текст: иначе ссылка ведёт на адрес с
    // запятой на конце и открывается страницей «не найдено».
    const trimmed = raw.replace(TRAILING, '');

    if (start > index) {
      parts.push({ text: source.slice(index, start), href: null });
    }

    parts.push({ text: trimmed, href: trimmed });

    const tail = raw.slice(trimmed.length);
    if (tail !== '') {
      parts.push({ text: tail, href: null });
    }

    index = start + raw.length;
  }

  if (index < source.length) {
    parts.push({ text: source.slice(index), href: null });
  }

  return parts;
}
